'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _demographicsLocationTable = require('../demographics-location-table');

var _demographicsLocationTable2 = _interopRequireDefault(_demographicsLocationTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstagramDemographicsCountriesTable = function InstagramDemographicsCountriesTable(_ref) {
  var uniqueKey = _ref.uniqueKey,
      data = _ref.audienceLocations.data;
  return _react2.default.createElement(_demographicsLocationTable2.default, {
    uniqueKey: uniqueKey,
    data: data,
    metric: 'absolute',
    metricLabel: 'Followers',
    itemLabel: 'Country'
  });
};

InstagramDemographicsCountriesTable.propTypes = {
  audienceLocations: _propTypes2.default.object.isRequired
};

exports.default = InstagramDemographicsCountriesTable;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/instagram-demographics-countries-table/index.js
 ** module id = 602
 ** module chunks = 0
 **/